/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserResponseDto = {
    /**
     * Unique user identifier (UUID)
     */
    id: string;
    /**
     * Auth0 user identifier
     */
    authId: string;
    /**
     * User email address
     */
    emailAddress: string;
    /**
     * Whether the email address has been verified
     */
    emailVerified: boolean;
    /**
     * User first name
     */
    firstName?: string | null;
    /**
     * User last name
     */
    lastName?: string | null;
    /**
     * Whether multi-factor authentication is enabled
     */
    mfaEnabled: boolean;
    /**
     * User account status
     */
    status: UserResponseDto.status;
    /**
     * User roles
     */
    roles: Array<'SUPER_ADMIN' | 'BUSINESS_ADMIN' | 'FINANCE_ADMIN' | 'ADVISER'>;
    /**
     * UUID of the Adviser this user is associated with
     */
    adviserId?: string | null;
    /**
     * UUID of the FAP (Financial Advice Provider) this user belongs to
     */
    fapId?: string | null;
    /**
     * Last login timestamp
     */
    lastLogin?: string | null;
    /**
     * User creation timestamp
     */
    createdAt: string;
    /**
     * User last update timestamp
     */
    updatedAt: string;
};
export namespace UserResponseDto {
    /**
     * User account status
     */
    export enum status {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
}

